module.exports = __webpack_public_path__ + "media/images/icons/country_flags/fr-0313c7eacb9633130ffbfac55230c2d2.svg";